import { createAction } from "@reduxjs/toolkit";

const saveLocalFilters = createAction("saveLocalFilters");
const clearAllFilters = createAction("clearAllFilters");

export { saveLocalFilters, clearAllFilters };
